import React from "react";
import { useLocation } from "react-router-dom";
import "./IndustriesSec3.css";

// ⭐ ENGLISH DATA
import {
  defaultData,
  oilAndGasData,
  powerAndUtilitiesData,
  lifeScienceData,
  wasteManagementData,
  miningAndMineralsData,
  healthcareData,
  privateEquityData,
  professionalServiceData,
  publicSectorData,
  realEstateConstructionData,
  mediaEntertainmentData,
  technologyData,
  telecommunicationData,
} from "../../../Data/IndustriesSec3Data";

// ⭐ FRENCH DATA
import {
  defaultData as defaultDataFR,
  oilAndGasData as oilAndGasDataFR,
  powerAndUtilitiesData as powerAndUtilitiesDataFR,
  lifeScienceData as lifeScienceDataFR,
  wasteManagementData as wasteManagementDataFR,
  miningAndMineralsData as miningAndMineralsDataFR,
  healthcareData as healthcareDataFR,
  privateEquityData as privateEquityDataFR,
  professionalServiceData as professionalServiceDataFR,
  publicSectorData as publicSectorDataFR,
  realEstateConstructionData as realEstateConstructionDataFR,
  mediaEntertainmentData as mediaEntertainmentDataFR,
  technologyData as technologyDataFR,
  telecommunicationData as telecommunicationDataFR,
} from "../../../Data/French/IndustriesSec3DataFR";

export default function IndustriesSec3({ currentLanguage = "en" }) {
  const location = useLocation();
  const isFrench = currentLanguage === "fr";

  // =========================== PATH CHECKS
  const isOilAndGasPage =
    location.pathname === "/industries/naturalresourcesandenergy/oilandgas";
  const isPowerAndUtilitiesPage =
    location.pathname === "/industries/naturalresourcesandenergy/powerandutilities";
  const isWasteManagementPage =
    location.pathname === "/industries/naturalresourcesandenergy/wastemanagement";
  const isMiningAndMineralsPage =
    location.pathname === "/industries/naturalresourcesandenergy/miningandminerals";
  const isLifeSciencePage = location.pathname === "/industries/lifescience";
  const isHealthcarePage = location.pathname === "/industries/healthcare";
  const isPrivateEquityPage = location.pathname === "/industries/privateequity";
  const isProfessionalServicePage = location.pathname === "/industries/professionalservice";
  const isPublicSectorPage = location.pathname === "/industries/publicsector";
  const isRealEstateConstructionPage = location.pathname === "/industries/realestateconstruction";

  // NEW TMT PATHS
  const isMediaPage =
    location.pathname ===
    "/industries/technologymediaentertainmenttelecommunications/mediaandentertainment";
  const isTechnologyPage =
    location.pathname ===
    "/industries/technologymediaentertainmenttelecommunications/technology";
  const isTelecommunicationPage =
    location.pathname ===
    "/industries/technologymediaentertainmenttelecommunications/telecommunication";

  // =========================== LANGUAGE DATA MERGE
  const languageData = {
    defaultData: isFrench ? defaultDataFR : defaultData,
    oilAndGasData: isFrench ? oilAndGasDataFR : oilAndGasData,
    powerAndUtilitiesData: isFrench ? powerAndUtilitiesDataFR : powerAndUtilitiesData,
    wasteManagementData: isFrench ? wasteManagementDataFR : wasteManagementData,
    miningAndMineralsData: isFrench ? miningAndMineralsDataFR : miningAndMineralsData,
    lifeScienceData: isFrench ? lifeScienceDataFR : lifeScienceData,
    healthcareData: isFrench ? healthcareDataFR : healthcareData,
    privateEquityData: isFrench ? privateEquityDataFR : privateEquityData,
    professionalServiceData: isFrench ? professionalServiceDataFR : professionalServiceData,
    publicSectorData: isFrench ? publicSectorDataFR : publicSectorData,
    realEstateConstructionData: isFrench
      ? realEstateConstructionDataFR
      : realEstateConstructionData,
    mediaEntertainmentData: isFrench ? mediaEntertainmentDataFR : mediaEntertainmentData,
    technologyData: isFrench ? technologyDataFR : technologyData,
    telecommunicationData: isFrench ? telecommunicationDataFR : telecommunicationData,
  };

  // =========================== FINAL MERGED DATA
  const data = isOilAndGasPage
    ? languageData.oilAndGasData
    : isPowerAndUtilitiesPage
    ? languageData.powerAndUtilitiesData
    : isWasteManagementPage
    ? languageData.wasteManagementData
    : isMiningAndMineralsPage
    ? languageData.miningAndMineralsData
    : isLifeSciencePage
    ? languageData.lifeScienceData
    : isHealthcarePage
    ? languageData.healthcareData
    : isPrivateEquityPage
    ? languageData.privateEquityData
    : isProfessionalServicePage
    ? languageData.professionalServiceData
    : isPublicSectorPage
    ? languageData.publicSectorData
    : isRealEstateConstructionPage
    ? languageData.realEstateConstructionData
    : isMediaPage
    ? languageData.mediaEntertainmentData
    : isTechnologyPage
    ? languageData.technologyData
    : isTelecommunicationPage
    ? languageData.telecommunicationData
    : languageData.defaultData;

  return (
    <div className="industriessec3-wrapper section">
      <h2 className="industriessec3-main-title">{data.mainTitle}</h2>
      <p className="industriessec3-main-subtitle">{data.mainSubtitle}</p>

      <div className="row industriessec3-twocols">
        <div className="col-md-6">
          <div className="industriessec3-section-title">
            <img src="/assets/icons/warning.png" alt="" />
            <span>{data.leftTitle}</span>
          </div>

          {data.challenges.map((item, index) => (
            <div key={index} className="industriessec3-box industriessec3-pinkbox">
              <h5 className="industriessec3-boxtitle">{item.title}</h5>
              <p className="industriessec3-boxtext">{item.text}</p>
            </div>
          ))}
        </div>

        <div className="col-md-6">
          <div className="industriessec3-section-title">
            <img src="/assets/icons/bulb.png" alt="" />
            <span>{data.rightTitle}</span>
          </div>

          {data.solutions.map((item, index) => (
            <div key={index} className="industriessec3-box industriessec3-greenbox">
              <h5 className="industriessec3-boxtitle">{item.title}</h5>
              <p className="industriessec3-boxtext">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
